import React, {useState} from 'react';
import { View, StyleSheet, Alert } from 'react-native';
import { withRouter } from "react-router-dom";

import {Card, ButtonImageWithText, InformationDialogue} from "../../../components";
import Colors from "../../../constants/Colors";

const JourneyActivitiesDeliveryCard = (props) => {

    const [forumBlockedModal, setForumVisibility] = useState(false);
    const [applicationBlockedModal, setApplicationVisibility] = useState(false);

    return (
        <Card containerStyle={{ margin: 20, marginBottom: 8, padding: 12, justifyContent: 'flex-start', alignItems: 'center' }}>

            <InformationDialogue
                isModalVisible={forumBlockedModal}
                titleText={"Fórum"}
                descriptionText={"O Fórum para esta jornada não está liberado!"}
                onClose={() => setForumVisibility(false)}
            />

            <InformationDialogue
                isModalVisible={applicationBlockedModal}
                titleText={"Colocar em Prática"}
                descriptionText={"A secção 'Colocar em Prática' não está liberada para esta jornada!"}
                onClose={() => setApplicationVisibility(false)}
            />

            <View style={{ flexDirection: 'row' }}>

                <ButtonImageWithText
                    text={'Fórum'}
                    onPress={() => {

                        if (props.forumEnabled === false) {
                            setForumVisibility(true);
                            return;
                        }

                        props.history.push('/forum')
                    }}
                    imageSrc={require('../../../imageImports/journeyForum.png')}
                    propsContainerStyle={styles.buttonContainerStyle}
                    propsImageStyle={styles.imageStyle}
                    propsTextStyle={styles.textStyle}
                    // resizeMode={'cover'}
                />

                <ButtonImageWithText
                    text={'Colocar em Prática'}
                    onPress={() => {

                        if (props.applicationEnabled === false) {
                            setApplicationVisibility(true)
                            return;
                        }

                        props.history.push('/applications')
                        // props.navigation.navigate('Delivery')
                    } }
                    imageSrc={require('../../../imageImports/journeyApplication.png')}
                    propsContainerStyle={styles.buttonContainerStyle}
                    propsImageStyle={styles.imageStyle}
                    propsTextStyle={styles.textStyle}
                    // resizeMode={'cover'}
                />

            </View>

        </Card>
    )
}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        height: 120,
        width: 160,
        flexDirection: 'column',
        backgroundColor: Colors.cardButtonBackground,
        borderRadius: 8,
        margin: 8
    },
    imageStyle: {
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        width: '100%',
        height: '76%'
    },
    textStyle: {
        color: Colors.cardButtonFontColor
    }
})

export default withRouter(JourneyActivitiesDeliveryCard);
